module.exports = __webpack_public_path__ + "img/comments-2.ae41e192.jpg";